<template>
  <div class="pc_index_header">
    <div class="pc_index_head">
      <div class="pc_index_head_left" @click="toHome">
        <div class="logo">
          <img class="img" src="../../static/image/index2.png" alt="" />
        </div>
        <div class="to_home" :class="{
        active: activeClass
      }">
          <!-- <van-icon name="wap-home-o" /> -->
          {{ $t('message.user.activity') }}
        </div>
        <!-- 影像 -->
        <div class="journalism" @click.stop="toJournalism" :class="{
        active: toJournalismActive
      }">
          {{ $t('message.user.News') }}
        </div>

        <div class="journalism" @click.stop="toPainting" :class="{
        active: pictureAlbumClass
      }">
          {{ $t('message.user.journal') }}
        </div>
      </div>
      <div class="pc_index_head_right">
        <div class="new_seach" v-show="activitySearch">
          <van-search shape="round" :placeholder="$t(searchPlaceholder)" @search="onSearch" @clear="onCancel"
            @input="inputSearch" v-model="activeSearch">
          </van-search>
          <!-- @pointercancel="onCancel" -->
        </div>

        <div class="bo" @click="languageChang(true)">
          <div class="word">
            <div>中</div>
            <div>En</div>
          </div>
          <div class="btn" :class="right ? 'aas' : ''" ref="qiehuan">中</div>
        </div>

        <div class="authentication" @click="newsContribution">
          {{ $t('message.news.contributeNews') }}
        </div>

        <div v-if="isShowUser" @click="$router.push('/user')" class="avaterDiv" @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave">
          <img :src="userInfo.headImgUrl
        ? userInfo.headImgUrl
        : 'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/index.png'
        " class="avater" />
          <span>{{ userInfo.nickName }}</span>

          <div class="select" v-show="selectShow" @mouseenter="handleMouseEnter">
            <div class="personal_details" @click="$router.push('/user')">
              {{ $t('message.user.profile') }}
            </div>
            <div class="log_out" @click="goActie">{{ $t('message.user.logout') }}</div>
          </div>
        </div>
        <div v-else class="avaterDiv">
          <img src="https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/index.png" class="avater" />
          <!-- <span @click="$router.push('/login/info')">{{ $t('message.login.sign') }}</span>
          <span @click="$router.push('/login/register')">{{ $t('message.login.register') }}</span> -->
          <span @click="toSing">{{ $t('message.login.sign') }}</span>
          <span @click="toRegister">{{ $t('message.login.register') }}</span>
        </div>
        <!-- 签约认证 -->
        <div class="authentication" @click="toAuthentication">
          <div class="img_box">
            <img src="../../static/image/999.png" alt="" />
          </div>

          {{ $t('message.my.signingCertification') }}
        </div>

        <!-- 问题反馈 -->
        <div class="feedback" @click="problemFeedback">
          <van-icon style="margin-right: 5px" name="question-o" size="20" color="#3562FF" />
          {{ $t('message.home.Feedback') }}
        </div>

        <!-- <div class="feedback" @click="problemFeedback">
          <van-icon style="margin-right: 5px" name="question-o" size="20" color="#3562FF" />
          {{ $t('message.home.Feedback') }}
        </div> -->
      </div>
    </div>

    <!-- 用户是否认证弹窗 -->
    <div class="authentication_toast" @click.self="clickHideToast" v-show="toastShow">
      <div class="toast_center">
        <div class="toast_center_main">
          <div class="context_icon">
            <img src="../../static/image/2666.png" alt="" />
          </div>

          <div class="context_text">
            {{ $t('message.news.realnameTip') }}
          </div>

          <div class="context_button" @click="clickToAuthentication">
            {{ $t('message.news.toCrtification') }}
          </div>
        </div>

        <div class="close" @click="clickHideToast"><van-icon name="cross" /></div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <div class="login_popup" v-if="loginPopup"></div>
    <transition :name="fade" type="animation">
      <div class="login_popupTwo" v-if="loginPopup" @click.self="showLoginPopup">
        <div class="login_popup_frame" ref="login_popup_frame">
          <div class="loginInfo" v-if="rotateX == '1'">
            <!-- registerInfo 注册 -->
            <!-- forgetClick 忘记密码 -->
            <loginInfo @registerInfo="registerInfo" @forgetClick="forgetClick" @clickClose="clickClose"></loginInfo>
          </div>
          <!-- 注册 -->
          <div class="register" v-else-if="rotateX == '2'">
            <registerInfo @clickClose="clickClose" @backTo="backTo"></registerInfo>
          </div>

          <!-- 忘记密码 -->
          <div class="forgetPassword" v-else-if="rotateX == '3'">
            <forgetPassword @clickClose="clickClose" @backTo="backTo"></forgetPassword>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
const defaultQuery = Object.freeze({
  pageNum: 0,
  pageSize: 300,
  language: sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang')
})
import { apiUser } from '@/api/user.js'
import { getCookie } from '@/utils/cookie'
import { clearCookie } from '@/utils/cookie'
import { Toast } from 'vant'
import { selectIsAuthentication } from '@/api/journalism.js'
import loginInfo from '../views/login/cpn/children/loginInfo.vue'
import registerInfo from '../views/login/cpn/children/registerInfo.vue'
import forgetPassword from '../views/login/cpn/children/forgetPassword.vue'
export default {
  components: {
    loginInfo,
    registerInfo,
    forgetPassword
  },
  props: {
    login: {
      type: Boolean
    }
  },
  data() {
    return {
      searchPlaceholder: '', //搜索占位符内容
      right: sessionStorage.getItem('bl'),
      // 用户信息
      userInfo: {},
      isShowUser: false,
      queryInfo: { ...defaultQuery },
      selectShow: false, //
      toJournalismActive: false, // 影像选中状态
      activeSearch: '', // 搜索活动的值
      activitySearch: false, // 搜索框是否显示
      toastShow: false,
      pictureAlbumClass: false,
      activeClass: false,
      loginPopup: false, // 登录弹窗
      rotateX: '1',
      fade: 'fade'
    }
  },
  computed: {},
  watch: {
    login: {
      handler(newName, oldName) {
        // console.log(newName,'newName');
        // console.log(oldName,'oldName');
        // if (newName) {
        // console.log('未登录')
        this.rotateX = '1'
        this.loginPopup = true
        // }
      }
      // immediate: true,
      // deep: true
    }
  },
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    // 判断路由
    if (this.$route.path == '/toJournalismList') {
      // 影像
      this.toJournalismActive = true
    } else if (this.$route.path == '/pictureAlbum') {
      // 画册
      this.pictureAlbumClass = true
    } else if (this.$route.path == '/') {
      this.activeClass = true
    }

    console.log(this.$route.path, 'path', this.$route.path == '/activity/works')

    if (
      this.$route.path == '/activity/works' ||
      this.$route.path == '/activity/award' ||
      this.$route.path == '/toJournalismList'
    ) {
      this.searchPlaceholder =
        this.$route.path == '/toJournalismList'
          ? 'message.news.searchPlaceholder'
          : 'message.nickname'
      this.activitySearch = true
    }
    let token = getCookie('token')
    if (token) {
      this.getUser()
      this.isShowUser = true
    } else {
      this.isShowUser = false
    }
  },
  mounted() {
    if (sessionStorage.getItem('bl') == 'false') {
      this.right = true
    }
    if (sessionStorage.getItem('bl') == 'true') {
      this.right = false
    }
    this.languageChang()
  },
  methods: {
    // 返回
    backTo() {
      this.rotateX = 1
    },
    // 登录关闭按钮
    clickClose() {
      // this.fade = 'fadeAway'
      // setTimeout(() => {
      //   this.loginPopup = false
      // }, 100)

      this.rotateX = 1
      this.loginPopup = false
    },
    // 去登录
    toSing() {
      this.rotateX = 1
      this.loginPopup = true
    },
    // 去注册
    toRegister() {
      this.rotateX = 2
      // this.rotateX = true
      this.loginPopup = true
    },
    // 忘记密码
    forgetClick() {
      this.rotateX = 3
      this.loginPopup = true
    },
    // 隐藏弹窗
    showLoginPopup() {
      this.rotateX = 1
      this.loginPopup = false
      // this.rotateX = false
    },
    // 注册
    registerInfo() {
      this.rotateX = 2
      // this.rotateX = true
    },
    // 搜索
    onSearch() {
      this.$emit('onSearch', this.activeSearch)
    },
    //取消
    onCancel() {
      this.$emit('onCancel', this.activeSearch)
    },
    inputSearch(val) {
      if (!val) {
        this.onCancel()
      }
    },
    // 去首页
    toHome() {
      // sessionStorage.removeItem('isWorkShow')
      this.$router.push('/')
    },
    // 去认证
    clickToAuthentication() {
      this.$router.push({
        path: '/user/certification'
      })
    },
    //语言切换
    languageChang(tr) {
      sessionStorage.setItem('bl', !this.right)
      this.right = !this.right
      let tt = ''
      if (this.right == false) {
        this.context = '中'
        tt = 'zhcn'
        this.queryInfo.language = tt
      }
      if (this.right == true) {
        this.context = 'En'
        tt = 'en'
        this.queryInfo.language = tt
      }
      if (tr) {
        this.langChange(tt, true)
      } else {
        this.langChange(tt)
      }

      this.$refs.qiehuan.innerHTML = this.context
      // this.search()
    },
    langChange(value, tr) {
      this.selectValue = value
      // console.log(this.selectValue)
      sessionStorage.setItem('lang', this.selectValue)
      this.$i18n.locale = this.selectValue
      if (tr) {
        this.$emit('search')
      }
    },
    // 获取登录信息
    async getUser() {
      const { data: res } = await apiUser()
      if (res.resultCode === 200) {
        this.userInfo = res.data
      }
    },
    // 问题反馈
    problemFeedback() {
      window.open('https://support.qq.com/product/466423')
      // console.log('问题反馈')
    },
    // 鼠标移入头像
    handleMouseEnter() {
      this.selectShow = true
      // console.log('移入了')
    },
    // 鼠标移出头像
    handleMouseLeave() {
      this.selectShow = false
      // console.log('移出了')
    },
    // 退出登录
    goActie() {
      clearCookie('token')
      clearCookie('userId')
      clearCookie('nickName')
      clearCookie('realName')
      clearCookie('hint')
      Toast.success(this.$t('message.user.logged'))
      setTimeout(() => {
        this.$router.push({
          name: 'Activity'
        })
      }, 1000)
    },
    // 去影像页面
    toJournalism() {
      // /works/toJournalismList
      // 已在影像页面
      if (this.$route.path == '/toJournalismList') {
        return
      }
      this.$router.push({
        path: '/toJournalismList'
      })
    },

    // 前往画册
    toPainting() {
      this.$router.push({
        path: '/pictureAlbum'
      })
    },

    async newsContribution() {
      let token = getCookie('token')
      if (!token) {
        Toast.fail(this.$t('message.home.first_log'))
        this.rotateX = 1
        this.loginPopup = true
        // setTimeout(() => {
        //   this.$router.push({
        //     name: 'Login'
        //   })
        // }, 1000)
        return
      }
      let userId = getCookie('userId')
      const { data: res } = await selectIsAuthentication({
        appId: userId
      })
      // 1->未认证;2->认证中;3->已认证 4 失败 5黑名单
      // console.log(res)
      // let token = false
      if (token && res.data != 1 && res.data != 2 && res.data != 4 && res.data != 5) {
        this.$router.push({
          path: '/toJournalismList/contribute',
          query: {
            index: 2
          }
        })
      } else if (res.data == '2') {
        Toast({
          message: `您的身份正在审核中，等审核通过后，才能进行投稿`,
          position: 'top'
        })
      } else if (res.data == '1' || res.data == '4') {
        this.toastShow = true
      } else if (res.data == '5') {
        Toast({
          message: `您的账号目前异常，暂不能投稿，请去客服中心联系管理员查看具体原因`,
          position: 'top'
        })
      }
    },
    // 隐藏弹窗
    clickHideToast() {
      this.toastShow = false
    },

    // 签约
    toAuthentication() {
      let token = getCookie('token')
      if (token) {
        if (this.$route.path == '/user/certification') {
          return
        }
        this.$router.push({
          path: '/user/certification'
        })
      } else {
        Toast.fail(this.$t('message.home.first_log'))
        this.rotateX = 1
        this.loginPopup = true
        // setTimeout(() => {
        //   this.$router.push({
        //     name: 'Login'
        //   })
        // }, 1000)
      }
    }
  }
}
</script>
<style scoped lang="less">
a {
  text-decoration: none;
  /* 去除默认的下划线 */
  color: #000;
  /* 去除默认的颜色和点击后变化的颜色 */
}

.pc_index_header {
  width: 100%;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  border-radius: 0px;
  background-color: #ffffff;
  z-index: 999;
  position: sticky;
  top: 0px;

  .pc_index_head {
    width: 90%;
    margin: 0px auto;

    display: flex;
    justify-content: space-between;
    height: 44px;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    align-items: center;

    .pc_index_head_left {
      cursor: pointer;
      display: flex;

      .logo {
        display: flex;
        align-items: center;
        margin-right: 30px;

        .img {
          width: 46px;
          height: 29px;
        }
      }

      .journalism {
        margin-left: 35px;
        display: flex;
        align-items: center;
      }

      .journalism:hover {
        color: #3562ff;
      }

      .to_home {
        display: flex;
        align-items: center;
      }

      .to_home:hover {
        color: #3562ff;
      }

      .active {
        color: #3562ff;
      }
    }

    .pc_index_head_right {
      cursor: pointer;
      height: 44px;
      display: flex;
      align-items: center;

      .new_seach {
        width: 280px;
        margin-right: 40px;

        /deep/.van-search {
          padding: 0;
        }
      }

      .avater {
        height: 36px;
        width: 36px;
        border-radius: 50%;
      }

      .avaterDiv {
        display: flex;
        align-items: center;
        position: relative;
        margin-left: 20px;

        .select {
          width: 100px;
          height: 60px;
          position: absolute;
          bottom: -60px;
          left: 0;
          border: 1px solid #efefef;
          border-top: 0;
          font-size: 14px;
          z-index: 999;

          .personal_details {
            width: 100%;
            height: 50%;
            display: flex;
            align-items: center;
            background-color: #fff;
            justify-content: center;
          }

          .personal_details:hover {
            background-color: #d7dbe7;
            color: #3562ff;
          }

          .log_out {
            width: 100%;
            height: 50%;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .log_out:hover {
            background-color: #d7dbe7;
            color: #3562ff;
          }
        }
      }

      span {
        margin-left: 12px;
      }

      // 中英切换
      .bo {
        position: relative;
        width: 50px;
        height: 25px;
        // left: 30px;
        // background-color: rgba(0, 0, 0, 0.3);
        background-color: #ffffff;
        border: 1px solid #efefef;
        border-radius: 12.5px;
        margin-left: 30px;

        .word {
          display: flex;
          justify-content: space-between;
          // color: #fff;
          color: black;

          height: 100%;
        }

        .word div {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50%;
          font-size: 12px;
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          // background-color: rgb(255, 255, 255);
          // color: #000;
          color: white;

          background-color: #3562ff;
          position: absolute;
          top: 0;
          left: 0;
          width: 25px;
          height: 25px;
          border-radius: 50%;
        }

        .aas {
          left: 25px;
        }
      }

      .authentication {
        display: flex;

        .img_box {
          width: 12px;
          height: 13px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        color: #1a1a1a;
        margin-left: 20px;
        font-size: 16px;
      }

      .feedback {
        font-size: 14px;
        color: #1a1a1a;
        margin-left: 30px;
        display: flex;
        cursor: pointer;
        align-items: center;

        &:hover {
          color: #3562ff;
        }
      }
    }
  }

  .authentication_toast {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    // opacity: 0.8;
    // background-color: #000000;
    background: rgba(0, 0, 0, 0.8);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;

    .toast_center {
      width: 267px;
      height: 354px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .toast_center_main {
        width: 100%;
        height: 300px;
        background-color: #fff;
        border-radius: 8px;
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: center;

        .context_icon {
          width: 113px;
          height: 122px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .context_text {
          color: #1a1a1a;
          font-size: 13px;
          max-width: 221px;
          text-align: center;
        }

        .context_button {
          width: 144px;
          height: 42px;
          border-radius: 21px;
          background-color: #3562ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .close {
        cursor: pointer;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border: 2px solid #fff;
      }
    }
  }

  // @keyframes fadeAway {
  //   0% {
  //     opacity: 1;
  //   }

  //   100% {
  //     opacity: 0;
  //   }
  // }

  // @keyframes enterFadeAway {
  //   0% {
  //     opacity: 0;
  //   }

  //   100% {
  //     opacity: 1;
  //   }
  // }

  // .fadeAway-enter {
  //   opacity: 0;
  // }
  // .fadeAway-enter-to {
  //   opacity: 1;
  // }
  // .fadeAway-leave {
  //   opacity: 1;
  // }
  // .fadeAway-leave-to {
  //   opacity: 0;
  // }
  // .fadeAway-enter-active {
  //   animation: enterFadeAway .8s;
  // }
  // .fadeAway-leave-active {
  //   animation: fadeAway .8s;
  // }

  @keyframes scale {
    0% {
      transform: scale(0.2);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes leaveScale {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.2);
    }
  }

  .fade-enter-active {
    animation: scale 0.3s;
  }

  .fade-leave-active {
    animation: leaveScale 0.3s;
  }

  .fade-enter {
    transform: scale(0.2);
  }

  .fade-enter-to {
    transform: scale(1);
  }

  .fade-leave {
    transform: scale(1);
  }

  .fade-leave-to {
    transform: scale(0.2);
  }

  .login_popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .login_popupTwo {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    .login_popup_frame {
      width: 600px;
      height: 501px;
      background-color: #fff;
      border-radius: 8px;
      z-index: 1;
      transform-style: preserve-3d;
      position: relative;
      transition: all 0.3s;

      .loginInfo {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }

      .register {
        position: absolute;
        left: 0;
        top: 0;
        // transform: rotateX(90deg) translateZ(250px);
        width: 600px;
        border-radius: 8px;
      }

      .forgetPassword {
        position: absolute;
        left: 0;
        top: 0;
        width: 600px;
        border-radius: 8px;
      }
    }

    .rotateX {
      transform: rotateX(-90deg);
    }
  }
}
</style>
